import type { ReactNode } from 'react'
import { cx } from './cx'
import '../fields.css'

export type FieldShellProps = {
  /** Id of the actual control; label htmlFor points at it. */
  id: string
  label: string
  required?: boolean
  error?: string
  hint?: string
  children: ReactNode
}

/**
 * Shared chrome for all labelled inputs: always-visible label (never a
 * placeholder-only label), hint text, and an assertive error message with
 * ids `${id}-hint` / `${id}-error` for aria-describedby wiring.
 */
export function FieldShell({ id, label, required = false, error, hint, children }: FieldShellProps) {
  return (
    <div className={cx('ui-field', error && 'ui-field--error')}>
      <label className="ui-field__label" htmlFor={id}>
        {label}
        {required && (
          <span className="ui-field__required" aria-hidden="true">
            {' '}
            *
          </span>
        )}
      </label>
      {children}
      {error ? (
        <p className="ui-field__error" id={`${id}-error`} role="alert">
          {error}
        </p>
      ) : hint ? (
        <p className="ui-field__hint" id={`${id}-hint`}>
          {hint}
        </p>
      ) : null}
    </div>
  )
}
